import { Route } from "react-router-dom";
import AuthLayout from "../layouts/AuthLayout";
import Login from "../pages/auth/Login";
import PasswordResetEmail from "../pages/auth/PasswordResetEmail";
import NewPassword from "../pages/auth/NewPassword";
import ResetSuccess from "../pages/auth/ResetSuccess";


const authRoutes = (
  <Route path="/" element={<AuthLayout />}>
    <Route index element={<Login/>} />
    <Route path="/reset-password-email" element={<PasswordResetEmail/>}/>
    <Route path="/reset-password" element={<NewPassword/>}/>
    <Route path="/reset-success" element={<ResetSuccess/>}/>
  </Route>
);

export default authRoutes;